import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import "./css/App.css";
import CampaignBuilder from "./pages/CampaignBuilder";

function App() {
    return (
        <Router>
            <Routes>
                <Route path="/" Component={CampaignBuilder} />
            </Routes>
        </Router>
    );
}

export default App;
